import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { tenantApi } from '../../api/tenants';

export function TenantCreatePage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [orgId, setOrgId] = useState(import.meta.env.VITE_ORG_ID ?? '');
  const [legalName, setLegalName] = useState('');
  const [gst, setGst] = useState('');
  const [country, setCountry] = useState('IN');
  const [activate, setActivate] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const created = await tenantApi.create({
        organization_id: orgId,
        name,
        slug: slug || undefined,
        activate,
        business: { legal_name: legalName || undefined, gst_number: gst || undefined, country },
        profile: { timezone: 'Asia/Kolkata', currency: 'INR', locale: 'en-IN' },
      });
      navigate(`/tenants/${created.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Create failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/tenants" className="text-sm text-slate-600 hover:underline">← Back to tenants</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Create tenant</h1>
      <p className="mt-1 text-sm text-slate-600">Provision a new operational boundary under your organization.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}

      <form onSubmit={onSubmit} className="mt-6 space-y-4 rounded-xl border border-slate-200 bg-white p-6">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Organization ID</span>
          <input required value={orgId} onChange={(e) => setOrgId(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Display name *</span>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Slug</span>
          <input value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="auto-generated" className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Legal name</span>
          <input value={legalName} onChange={(e) => setLegalName(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <div className="grid gap-4 md:grid-cols-2">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">GST number</span>
            <input value={gst} onChange={(e) => setGst(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Country</span>
            <input value={country} onChange={(e) => setCountry(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={activate} onChange={(e) => setActivate(e.target.checked)} />
          Activate immediately
        </label>
        <button type="submit" disabled={saving} className="rounded-lg bg-slate-900 px-4 py-2 text-white disabled:opacity-60">
          {saving ? 'Creating…' : 'Create tenant'}
        </button>
      </form>
    </div>
  );
}
